mutation UserProfileInvitationUpdate($input: UserProfileInvitationUpdateInput!) {
  userProfileInvitationUpdate(input: $input) {
    selectedEntities 
  }
}
